import { render, staticRenderFns } from "./groupBuyingDetail.vue?vue&type=template&id=a696cdae&scoped=true&"
import script from "./groupBuyingDetail.vue?vue&type=script&lang=js&"
export * from "./groupBuyingDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyingDetail.vue?vue&type=style&index=0&id=a696cdae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a696cdae",
  null
  
)

export default component.exports